/**
 * Alexia Shop - Vue 3 Application Entry Point
 * =============================================
 * Main entry point for the Vue 3 SPA.
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { i18n, initI18n } from './i18n'

// Import global styles
import './assets/main.css'

// Create Vue app
const app = createApp(App)

// Install plugins
app.use(createPinia())
app.use(router)
app.use(i18n)

// Initialize i18n and mount app
initI18n().then(() => {
  app.mount('#app')
})
